/** 가입 관련 요청에만 인증 정보를 전달한다. 전역 axios 설정에 보관하지 않는다. */
export interface SignupCredentials {
    socialProvider?: string;
    socialAccessToken?: string;
}
export const signupIdentityConfig = (credentials?: SignupCredentials | null) => ({
    headers: credentials?.socialAccessToken ? {
        'X-Signup-Provider': credentials.socialProvider ?? 'NAVER',
        'X-Signup-Token': credentials.socialAccessToken,
    } : {},
});
